/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbqualifier": {
        "nested": {
          "service": {
            "nested": {
              "GetEligibilityResponse": {
                "nested": {
                  "FailedRequirement": {
                    "nested": {
                      "Reason": {
                        "values": {
                          "UNKNOWN_REASON": 0,
                          "SUSPENDED_BY_ISSUER": 1,
                          "DEACTIVATED_BY_ISSUER": 2,
                          "SUSPECTED_ATO": 3,
                          "FAKE_ACCOUNT": 4,
                          "UNIT_NOT_ACTIVE": 5,
                          "MCC_INELIGIBLE": 6,
                          "DEACTIVATED_BY_RISK": 7,
                          "EXHAUSTED_VERIFICATION_RETRIES": 8,
                          "SELLS_CANNABIS": 9,
                          "PRODUCT_LEVEL_HARDBLOCKED_BY_COMPLIANCE": 10
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbqualifier?.nested?.service?.nested?.GetEligibilityResponse?.nested?.FailedRequirement?.nested?.Reason) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GetEligibilityResponse @ squareup/bbqualifier/eligibility_service.proto at 79:1
 */
export const GetEligibilityResponse = {};
/**
 * SOURCE FailedRequirement @ squareup/bbqualifier/eligibility_service.proto at 90:3
 */
GetEligibilityResponse.FailedRequirement = {};
/**
 * SOURCE Reason @ squareup/bbqualifier/eligibility_service.proto at 94:5
 */
GetEligibilityResponse.FailedRequirement.Reason = $root.lookupEnum('squareup.bbqualifier.service.GetEligibilityResponse.FailedRequirement.Reason').values;